<template>
  <div class="panel panel-default">
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="panel-heading">
      <h4 class="panel-title">
        <a class="accordion-toggle" data-toggle="collapse" v-bind:href="randomGroupPassagesHref(item.userId)" aria-expanded="true" @click="getData(item.userId, $event)">
          <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
          &nbsp;解錠可能ゲート
        </a>
      </h4>
    </div>
    <div class="panel-collapse collapse" :id="randomGroupPassagesClass(item.userId)" aria-expanded="true">
      <div class="panel-body">
        <table style="min-width:100%" class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <th>ゲートID</th>
              <th>ゲート名</th>
              <th>ゲートグループ</th>
            </tr>
          </thead>
          <tbody v-if="loopData!=null">
            <template v-for="(item, index) in loopData">
              <tr :key="index" v-if="item.gateId.isValid">
                <td><a class="link" @click="viewGate(item.gateId.gateId)">{{item.gateId.gateId}}</a></td>
                <td>{{item.gateId.gateName}}</td>
                <td>{{item.groupId.name}}</td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="3">{{message}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  props: ['item'],
  data () {
    return {
      loading: false,
      listGroupPassages: [],
      tempGroupPassages: null,
      listrelationsGateGroup: null,
      loopData: null,
      exeGateGroup: 0,
      exeGetInforGate: 0,
      exeGetInforGroup: 0,
      totalGateGroup: 0,
      totalGate: 0,
      message: 'データー取得中'
    }
  },
  watch: {
    exeGateGroup: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalGateGroup) {
        vm.getGateGroup(vm.tempGroupPassages[newVal].groupId)
      } else if (newVal > 0 && newVal === vm.totalGateGroup) {
        vm.totalGate = vm.listGroupPassages.length
        if (vm.totalGate > 0) {
          vm.getInforGate(vm.listGroupPassages[0].gateId, 0)
        } else {
          this.loading = false
          this.message = 'データーはありません'
        }
      }
    },
    exeGetInforGate: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < (vm.totalGate)) {
        vm.getInforGate(vm.listGroupPassages[newVal].gateId, newVal)
      } else if (newVal > 0 && newVal === (vm.totalGate)) {
        vm.getInforGroup(vm.listGroupPassages[0].groupId, 0)
      }
    },
    exeGetInforGroup: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < (vm.totalGate)) {
        vm.getInforGroup(vm.listGroupPassages[newVal].groupId, newVal)
      } else if (newVal > 0 && newVal === (vm.totalGate)) {
        vm.loopData = vm.listGroupPassages
        vm.loading = false
      }
    }
  },
  methods: {
    getData: function (userId, event) {
      this.loopData = null
      this.listGroupPassages = []
      this.listrelationsGateGroup = null
      this.tempGroupPassages = null
      this.exeGateGroup = 0
      this.exeGetInforGate = 0
      this.exeGetInforGroup = 0
      this.getInforGroupPassage(userId)
    },
    // ゲート取得
    getInforGate (gateId, i) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId) + '&isValid=true')
        .then(response => {
          vm.listGroupPassages[i].gateId = response.body.gates[0]
          vm.exeGetInforGate++
        })
        .catch((error) => {
          vm.exeGetInforGate++
          console.log(error)
        })
    },
    // ゲートグループ取得
    getInforGroup (groupId, i) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          vm.listGroupPassages[i].groupId = response.body.groups[0]
          vm.exeGetInforGroup++
        })
        .catch((error) => {
          vm.exeGetInforGroup++
          console.log(error)
        })
    },
    // ゲート&グループ連関取得
    getGateGroup (groupId) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          console.log(response)
          vm.listrelationsGateGroup = response.body.relationsGateGroup
          for (var i = 0; i < vm.listrelationsGateGroup.length; i++) {
            vm.listGroupPassages.push(vm.listrelationsGateGroup[i])
          }
          vm.exeGateGroup++
        })
        .catch((error) => {
          vm.exeGateGroup++
          console.log(error)
        })
    },
    // ゲートグループ通行権限取得
    getInforGroupPassage (userId) {
      var vm = this
      this.loading = true
      this.$http.get(Config.GROUPS_PASSAGE_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          if (response.body.maxRecords > 0) {
            console.log(response)
            vm.tempGroupPassages = response.body.groupPassages
            vm.totalGateGroup = vm.tempGroupPassages.length
            vm.getGateGroup(vm.tempGroupPassages[0].groupId)
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
          this.message = 'データーはありません'
        })
    },
    viewGate (id) {
      let routeData = this.$router.resolve({name: 'gateedit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    randomGroupPassagesClass (classname) {
      return 'GroupPassages' + this.removeSpecialSymboy(classname)
    },
    randomGroupPassagesHref (classname) {
      return '#GroupPassages' + this.removeSpecialSymboy(classname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/UserDetailGroup.vue